// import { useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
import QrTicketInfo from '../../components/Qr/QrTicket/QrTicketInfo'
import ButtonBack from '../../components/reusable/Buttons/ButtonBack'
// import { qrSelector } from '../../redux/slices/qr'
// import { fetchOrders } from '../../redux/thunks/qr'

const QrTicket = () => {
  // const { orders } = useSelector(qrSelector)

  // const dispatch = useDispatch()
  // useEffect(() => {
  //   if (orders?.length < 1) dispatch(fetchOrders())
  // }, [dispatch, orders])

  return (
    <div className="qr_ticket_page wrapper_480">
      <ButtonBack />
      <QrTicketInfo />
    </div>
  )
}

export default QrTicket
